"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const TabContext_1 = __importDefault(require("../../contexts/TabContext"));
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const helpers_1 = require("../../lib/helpers");
const TabPanel = (props) => {
    const { children, name } = props;
    const { currentTab, registerTabPanel, panelsRef, urlPropName } = react_1.useContext(TabContext_1.default);
    registerTabPanel(name);
    const primitiveProps = helpers_1.usePrimitiveProps(props);
    let shouldRender = currentTab === name;
    /* This is first tab panel render with no provided value in <Tabs> */
    if (!currentTab) {
        /* This allows us to provide SSR support for <Tabs> which dont provide any value, we assume the first tab panel is the one to be rendering. */
        const isFirstTabPanel = panelsRef.current[0].name === name;
        shouldRender = isFirstTabPanel;
    }
    if (!shouldRender) {
        return null;
    }
    return (react_1.default.createElement("div", Object.assign({}, primitiveProps), children));
};
exports.default = withJourney_1.default('j-tab-panel', TabPanel);
